var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 74,
    viewBox: "0 0 76 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F44",
    d: "M3.32 53.976C.19 47.918-.797 40.92.66 33.962c2.482-11.866 12.233-21.185 24.195-23.148 20.393-3.348 37.85 14.112 34.505 34.505-1.963 11.962-11.284 21.713-23.148 24.196-6.96 1.456-13.958.469-20.015-2.661l-8.323 1.998c-3.945.947-7.5-2.607-6.554-6.552l2-8.324",
    opacity: 0.2,
    transform: "translate(-159 -166) translate(0 96) translate(159 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.642 18C17.136 18 7 28.136 7 40.642c0 4.642 1.402 8.955 3.798 12.547l-1.987 8.283 8.283-1.99c3.592 2.397 7.905 3.801 12.548 3.801 12.505 0 22.641-10.138 22.641-22.641C52.283 28.136 42.147 18 29.642 18z",
    transform: "translate(-159 -166) translate(0 96) translate(159 72)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.623,
    d: "M29.642 18C17.136 18 7 28.136 7 40.642c0 4.642 1.402 8.955 3.798 12.547l-1.987 8.283 8.283-1.99c3.592 2.397 7.905 3.801 12.548 3.801 12.505 0 22.641-10.138 22.641-22.641C52.283 28.136 42.147 18 29.642 18zM63.56 9.2l-6.654 6.653m13.21 37.163l-5.588-1.498m9.088 2.436l-9.088-2.436m-8.218 17.89l-2.047-2.045m16.82-36.196l-5.588 1.497M42.56 0L41.06 5.588",
    transform: "translate(-159 -166) translate(0 96) translate(159 72)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F44",
    d: "M30 48.167c1.108 0 2 .855 2 1.916C32 51.145 31.108 52 30 52s-2-.855-2-1.917c0-1.061.892-1.916 2-1.916zM30 29c1.108 0 2 .855 2 1.917v13.416c0 1.062-.892 1.917-2 1.917s-2-.855-2-1.917V30.917c0-1.062.892-1.917 2-1.917z",
    transform: "translate(-159 -166) translate(0 96) translate(159 72)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamation);
export default __webpack_public_path__ + "static/media/icon-exclamation.26ec9a832056aa70ebce2ddf4826aec1.svg";
export { ForwardRef as ReactComponent };